module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-1.png?1da1b988";